import React, { useEffect } from 'react';
import { Card, CardHeader } from '@core-ui/Components/ui/card.tsx';
import { CallerId } from '@features/numbers/components/Numbers/CallerId.tsx';
import { useBreadcrumbStore } from '@ui/Layout/store/useBreadcrumbStore.ts';
import NumbersSection from '@features/numbers/components/Numbers/NumbersSection.tsx';
import { getCurrentUser } from '@features/auth';

export function NumbersPageSettings (): React.JSX.Element {
  const setItems = useBreadcrumbStore((s) => s.setItems);

  const isSuperAdmin = getCurrentUser()?.isSuperAdmin ?? false;
  const isAdmin = getCurrentUser()?.isAdmin ?? false;

  useEffect(() => {
    setItems([
      { labelKey: 'breadcrumb.home', href: '/workspace/sessions/new' },
      { labelKey: 'breadcrumb.numbers', href: '/workspace/numbers' },
    ]);
  }, [setItems]);

  return (
    <>
      <div className="space-y-6">
        <Card className="shadow-lg border border-border bg-card text-foreground">
          <CardHeader className="px-0">
            <div className="items-start justify-between">
              <div className="ml-5 mr-5">
                <CallerId />
              </div>
            </div>
          </CardHeader>
        </Card>
      </div>
      <div>
        {(isSuperAdmin || isAdmin) && (
          <div className="space-y-6 mt-5">
            <div className="items-start justify-between">
              <div>
                <NumbersSection isSuperAdmin={isSuperAdmin} />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}